<template>
  <div>
    <ul>
      <li v-for="level in levels" :key="level.id">
        <router-link
          :to="'/maths/levels/' + level.id"
          @click="$emit('changeLevel', level)"
        >
          {{ level.name }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import apiCall from "@/func/net/apiCall";
import { SfMathsLevel } from "@/types/mathsTypes";

interface CmpData {
  levels: SfMathsLevel[];
}

export default defineComponent({
  data(): CmpData {
    return {
      levels: [],
    };
  },
  mounted() {
    this.loadLevels();
  },
  methods: {
    async loadLevels() {
      const data = await apiCall("math-level");
      if (data.success) {
        this.levels = data.data?.items;
      }
    },
  },
});
</script>
